import React from 'react';
import { Col, Row } from 'antd';

import { splitVisibleChips } from './utils';
import { SegmentChipItem } from './SegmentChipItem';
import { OverflowButton } from './OverflowButton';
import type { SegmentChip } from './utils';

interface ChipListProps {
	chips: SegmentChip[];
	disabled?: boolean;
	onIdentify: () => void;
	onRemove: (segmentId: string) => void;
}

export function ChipList({ chips, disabled = false, onIdentify, onRemove }: Readonly<ChipListProps>): JSX.Element {
	const { visibleChips, overflowCount } = splitVisibleChips(chips);

	return (
		<Row align="middle" justify="center" gutter={4} wrap={false}>
			{visibleChips.map((chip) => (
				<Col key={chip.segmentId}>
					<SegmentChipItem
						label={chip.label}
						disabled={disabled}
						onRemove={onRemove}
						segmentId={chip.segmentId}
					/>
				</Col>
			))}
			{!!overflowCount && (
				<Col>
					<OverflowButton count={overflowCount} disabled={disabled} onClick={onIdentify} />
				</Col>
			)}
		</Row>
	);
}
